<template>
  <div class="main">
    <div class="title-bg" v-if="!isMobile"><div class="pulse-logo"></div></div>
    <div class="app-content" v-if="ready">
      <div class="header-container" ref="headerContainer">
        <app-header @selectIndicator="current_ind=$event"></app-header>
      </div>
      <div class="indicator-cards-container" ref="scrollContainer">
        <indicator-card v-for="(ind,i) in indicatorList" 
          :indicator="ind" 
          :key="ind.id"
          @next="scrollToNext"
          :hasNext="i<indicatorList.length-1"
          @indicatorEnter="onIndicatorEnter"
          @indicatorExit="onIndicatorExit"
          @openSharePanel="openSharePanel"
          ></indicator-card>
      </div>
      <div v-if="showRedirectPopup" class="jump-popup-wrapper">
        <div class="jump-popup-content">
          <div class="info-icon"></div>
          <div class="text" v-html="jumpDisclaimerText" @click="dismissRedirect"></div>
          <div class="close-button" @click="dismissRedirect"></div>
        </div>
      </div>
      <div v-if="showSharePanel" class="jump-popup-wrapper share-popup-wrapper">
        <div class="jump-popup-content share-popup-content">
          <share-panel :values="shareData" @close="() => showSharePanel = false"></share-panel>
        </div>
      </div>
    </div>
    <Loading v-else></Loading>
  </div>
</template>
<script>
// @ is an alias to /src
import Api from '@/api'
import Header from '@/components/headers/Header';
import { mapState } from 'vuex'

import IndicatorCard from '@/components/IndicatorCard';
import SharePanel from '@/components/SharePanel';

import scrollSnapPolyfill from 'css-scroll-snap-polyfill'
import Loading from '@/components/IndicatorCards/parts/Loader'
import EventBus from '@/utils/eventBus'

import ClickOutside from 'vue-click-outside'

scrollSnapPolyfill()
const debounce = require('debounce');
let _debouncedOnWheel = debounce(function (dir) {
    if(this.isMobile) return
    // console.log("onwheeel!!!!")
    if(dir>0) this.scrollToNext()
    else this.scrollToPrev()
    return false
  },800, true)
  
export default {
  name: 'Main',
  data () {
    return {
      current_ind: null,
      current_date: null,
      initialized: false,
      redirectDismissed: false,
      showSharePanel: false,
      shareData: {
        text: '',
        indicator: ''
      }
    }
  },
  routerLinkedData: ['current_ind','current_date'],
  mounted () {
    // ALL INIT CALLS
    this.$store.dispatch('loadIndicatorList')
    this.initData()

    this.indicatorsOnView = []
    
    window.addEventListener('resize',debounce(()=>{
      this.scrollToIndicator(this.current_ind,false)
    },200))
    //  @wheel = "onWheel" @scroll="onScroll"
    
  },
  updated () {
    if(!this.initialized && this.$refs.scrollContainer){
      this.initialized = true
      if(this.isMobile){
        window.document.addEventListener('scroll',this.onScroll)
        window.document.addEventListener('wheel',this.onWheel)
      } else {
        this.$refs.scrollContainer.addEventListener('scroll',this.onScroll)
        this.$refs.scrollContainer.addEventListener('wheel',this.onWheel)
      }
    }
  },
  components: {
    IndicatorCard,
    Loading,
    SharePanel,
    'app-header': Header
  },
  computed: {
    ...mapState(['indicatorList','nodeInfo','nodeFilters','redirectOrigin']),
    ready () {
      return this.indicatorList.length>0 && this.nodeInfo.id && this.nodeFilters.filters
    },
    showRedirectPopup () {
      return this.redirectOrigin !== null && !this.redirectDismissed
    },
    jumpDisclaimerText(){
      let originText = this.redirectOrigin.value
      let destText = this.nodeInfo.value+` (${this.t(this.nodeInfo.glk.toLowerCase())})`
      originText = `<span class='underlined'>${originText}</span>`
      destText = `<span class='underlined'>${destText}</span>`
      return this.t('jump_disclaimer').replace('%ORIGIN%',originText).replace('%DEST%',destText)    
    }
  },
  methods: {
    dismissRedirect () {
      
      this.redirectDismissed = true
      // HACER BIEN EStOS states 
      
      // -> QUE SE GUARDA EN LA STORE Y COMO SE LLAMA?!?!?!?
      
      
      // SE GUARDA UN "redirectOrigin" en la store (con TODO el metadata a ser posible)
      
      // -a parte un "data:{dismissed:true/false" aqui en la MAin que se resetea cuand ocabmia el "nodeInfo"
      
      // this.$store.dispatch('dismissRedirect')

      
      
      
    },
    initData() {
      this.$store.dispatch('setRedirectOrigin', null)
      this.$store.dispatch('loadNodeInfo', this.$route.params)
      this.$store.dispatch('loadNodeFilters', {...this.$route.params, date: this.current_date})
      this.initCompareNodeInfo()
    },
    scrollToNext() {
      let currentIndex = this.current_ind ? this.indicatorList.findIndex(d => d.id == this.current_ind) : 0
      if(currentIndex < this.indicatorList.length-1) {
        this.current_ind = this.indicatorList[currentIndex + 1].id
      }
    },
    scrollToPrev() {
      let currentIndex = this.current_ind ? this.indicatorList.findIndex(d => d.id == this.current_ind) : 0
      if(currentIndex > 0) {
        this.current_ind = this.indicatorList[currentIndex - 1].id
      }
    },
    scrollToIndicator(indId, transition=true) {
      // console.log("scrolling to")
      let el = this.$el.querySelector('#' + indId)
      // this.$scrollTo(el, transition?1000:1, {
      //     container: '.indicator-cards-container'
      // })
      if(el) {
        let eltop = el.offsetTop
        let headerHeight = this.$refs.headerContainer.clientHeight
        let scrollTo = eltop - (headerHeight*1.6 + 12)
        if(this.isMobile){
          window.scrollTo({top: Math.max(0,scrollTo) , behavior: 'smooth'})
        } else {
          this.$scrollTo(el, transition?1000:1, {
            container: '.indicator-cards-container'
          })
        }
      }
    },
    onIndicatorEnter(ind){
      this.indicatorsOnView.indexOf(ind) == -1 && this.indicatorsOnView.push(ind)
    },
    onIndicatorExit(ind){
      this.indicatorsOnView.indexOf(ind) !== -1 && this.indicatorsOnView.splice(this.indicatorsOnView.indexOf(ind), 1)
    },
    //BASURA, no hay manera.... lo dejo pa luego
    onWheel (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation()
      this.debouncedOnWheel(e.deltaY>0?1:-1)
    },
    debouncedOnWheel: _debouncedOnWheel,
    onScroll () {
      EventBus.$emit('scroll')
      this.debouncedOnScroll()
    },
    debouncedOnScroll: debounce(function () {
      let scrollHeight = window.innerHeight
      let best = this.indicatorsOnView.reduce((best, indId)=>{
        let el = this.$el.querySelector('#' + indId)
        let scrollPos 
        
        if(this.isMobile) scrollPos = el.offsetTop - window.scrollY
        else scrollPos = el.offsetTop - this.$refs.scrollContainer.scrollTop 
        
        let visibleArea = scrollPos>0?Math.abs(scrollHeight-scrollPos):Math.abs(scrollHeight+scrollPos)
        if(visibleArea > best.visibleArea) return {id:indId, visibleArea}
        else return best
      },{id:null, visibleArea: 0})
      _debouncedOnWheel.clear()
      this.current_ind = best.id
      // console.log("set current_ind",this.current_ind)
    },300),

    openSharePanel (shareVal) {
      this.showSharePanel = true
      this.shareData = shareVal
    },

    initCompareNodeInfo() {
      if(this.$route.query.compare_node_id && this.$route.query.compare_node_glk){
        this.$store.dispatch('loadCompareNodeInfo', {
          zoneId: this.$route.query.compare_node_id,
          glk: this.$route.query.compare_node_glk
        })
      } else {
         this.$store.commit('setCompareNodeInfo', {})
      }
    }
  },
  watch: {
    ready(){
      if(this.ready){
        // initial instant scroll to current_ind
        this.$nextTick(()=>{
          this.scrollToIndicator(this.current_ind,false)
        })    
      }
    },
    current_ind(){
      this.scrollToIndicator(this.current_ind)
    },
    current_date(){
      // this.initData() //?? no se podria hacer solo el "getNodeFilters"??
      this.$store.dispatch('loadNodeFilters', {...this.$route.params, date: this.current_date})
    },
    '$route.params.zoneId' () {
      this.current_ind = this.$store.state.indicatorList[0].id
      this.initData()
    },
    '$route.query.compare_node_id' () {
      this.initCompareNodeInfo()
    },
    nodeInfo(){
      this.redirectDismissed = false
    },
    showRedirectPopup(){
      if(this.showRedirectPopup) window.document.getElementsByTagName('body')[0].style.overflow = 'hidden'
      else window.document.getElementsByTagName('body')[0].style.overflow = null
    
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="stylus">
.main
  background: #F4F4F4
  // height: 100vh
  position: relative
  width: 100%
  min-height: 100vh;
  // Para las transiciones del header
  // .app-content
  //   overflow: hidden;
  .indicator-cards-container
    display: flex
    flex-grow 1
    flex-direction: column
  .mobile &
    .app-content
      // height: 100vh
      m-max-width-container(padding: 0)
      // overflow hidden
      display flex
      flex-direction column
    .header-container
      background: #ffffff
      flex-grow 0
      // border-bottom: 1px solid black
      width: 100%
      z-index: 10
      position sticky
      top 0

    .indicator-cards-container
      overflow-y: scroll
      scroll-padding: vh(10px)
      scroll-snap-type: y proximity
      width: 100%
      -webkit-overflow-scrolling: touch

  .desktop &
    height 100%
    
    .app-content
      overflow hidden
      position relative
    .title-bg
      align-items: center
      background-image url('~@/assets/images/bg/trama.png')
      background-repeat: repeat;
      color: #ffffff
      display: flex
      height: vh(80px)
      padding: vh(20px) vw(20px)
      .pulse-logo
        background-image url('~@/assets/images/pulse-logo.svg')
        background-size contain
        background-repeat: no-repeat;
        background-position: center left;
        height vh(60px)
        width vw(200px)
        margin-left vw(50px)

    .app-content
      height: "calc(100vh - %s)" % vh(120px)
      margin: auto
      margin-top: vh(20px)
      m-max-width-container(padding: 0)
      
    .header-container
      align-items: center
      background: #ffffff
      background: #ffffff
      display: flex
      z-index: 5;
      position: relative;
      width: 100%

    .indicator-cards-container
      background: #ffffff
      margin-top: vh(5px)
      height "calc(100% - %s)" % vh(80px)
      overflow: hidden
  
  .jump-popup-wrapper
    position: fixed;
    width 100%
    height 100%
    background: rgba(0,0,0,0.6)
    z-index: 4;
    top 0
    left 0
    &.share-popup-wrapper
      z-index: 10
  
    .jump-popup-content
      position: absolute;
      top: vh(200px);
      width: 40vw;
      background: #fff;
      left: 50%;
      transform: translate(-50%,0);
      padding: vw(40px) vh(40px) vw(50px) vh(40px);
      box-shadow 0 5px 6px rgba(0,0,0,0.2)
      &.share-popup-content
        width: 60vw;
        .mobile &
          overflow scroll
          max-height 90vh
          top: vh(20px)
          width: 90vw;
          padding: vw(15px) vw(15px) vw(15px) vw(15px);
          
      .mobile &
        top: vh(140px);
        width: 80vw;
      .info-icon
        margin 0 auto vh(10x) auto
        background-image url('~@/assets/icons/info_blue.svg')
        background-size contain
        background-repeat: no-repeat;
        background-position: center center;
        height vw(22px)
        width vw(22px)
      .text
        text-align center
        .underlined
          text-decoration underline
          font-style: italic
      .close-button
        position absolute 
        top vw(12px)
        right vw(12px)
        width vw(18px)
        height vw(18px)
        cursor pointer
        background-image url('~@/assets/icons/close-panel.svg')
        background-size contain
        background-repeat: no-repeat;
        background-position: center center;
</style>
